export default "__VITE_PUBLIC_ASSET__00f5f392__"